module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-css.ba5d66e1.gif";